import { MapPin, Calendar, Users, ArrowRight } from "lucide-react";

export default function SearchSummaryBar({ origin, destination, outboundDate, inboundDate, passengers, tripType }) {
  return (
    <div className="bg-card border border-border rounded-xl px-5 py-3.5 flex flex-wrap items-center gap-x-5 gap-y-2 shadow-sm">
      <div className="flex items-center gap-2 text-sm font-medium">
        <MapPin className="w-4 h-4 text-primary" />
        <span>{origin}</span>
      </div>
      <ArrowRight className="w-4 h-4 text-muted-foreground" />
      <div className="flex items-center gap-2 text-sm font-medium">
        <MapPin className="w-4 h-4 text-primary" />
        <span>{destination}</span>
      </div>
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <Calendar className="w-4 h-4" />
        <span>{outboundDate}</span>
      </div>
      {inboundDate && (
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Calendar className="w-4 h-4" />
          <span>{inboundDate}</span>
        </div>
      )}
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <Users className="w-4 h-4" />
        <span>{passengers} passenger{passengers > 1 ? "s" : ""}</span>
      </div>

    </div>
  );
}